import {
  SET_STORE_DETAIL,
  SET_USER_PROFILE,
  SET_COUNTRIES_INFO,
  SET_STORES_INFO,
  SET_GUEST_CART,
  SET_STORE,
  SET_GUEST_USER_PROFILE
} from './action-types';

export function setStoreDetail(data) {
  return {
    type: SET_STORE_DETAIL,
    data
  };
}

export function setUserProfile(data) {
  return {
    type: SET_USER_PROFILE,
    data
  };
}

export function setGuestUserProfile(data) {
  return {
    type: SET_GUEST_USER_PROFILE,
    data
  };
}

export function setCountriesInfo(data) {
  return {
    type: SET_COUNTRIES_INFO,
    data
  };
}

export function setStoresInfo(data) {
  return {
    type: SET_STORES_INFO,
    data
  };
}

export function setStore(data) {
  return {
    type: SET_STORE,
    data
  };
}

export function setGuestCart(data) {
  return {
    type: SET_GUEST_CART,
    data
  };
}

export default {
  setStoreDetail,
  setUserProfile,
  setGuestUserProfile,
  setCountriesInfo,
  setStoresInfo,
  setGuestCart,
  setStore
};



// WEBPACK FOOTER //
// ./src/app/auth/actions.js